export const MEASUREMENT_LIMITS_ENUM = Object.freeze({
  MAX: 'MAX',
  MIN: 'MIN',
  IN_BETWEEN: 'IN_BETWEEN',
  NOT_IN_BETWEEN: 'NOT_IN_BETWEEN',
});
